import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 16 16"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      d: "M4.905 12.905a5.33 5.33 0 0 0 5.644 1.223l.18-.068a1.333 1.333 0 0 0 .474-2.19l-.926-.927a1.333 1.333 0 0 0-1.886 0l-.448.447a1.33 1.33 0 0 1-1.885 0L4.61 9.944a1.333 1.333 0 0 1 0-1.886l.448-.448c.52-.52.52-1.364 0-1.885l-.927-.926a1.333 1.333 0 0 0-2.191.474l-.067.18a5.33 5.33 0 0 0 1.222 5.643zM8.49 5.699l1.624-3.207c.317-.626 1.261-.4 1.261.3v2.541h1.547c.495 0 .818.522.596.965l-1.61 3.22c-.313.626-1.257.407-1.263-.293l-.02-2.558h-1.54a.667.667 0 0 1-.595-.968"
    }
  )
);
var SvgCallBoltFilled = styled(SvgComponent)`
  ${size}
  ${color}
`;
var CallBoltFilled_default = SvgCallBoltFilled;

export { CallBoltFilled_default as default };
